/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const orderItemTableRowSX: SxProps<Theme> = {
	'.MuiTypography-body1': {
		lineHeight: 1.5,
	},
	'.MuiTypography-body2': {
		lineHeight: 1.5,
	},
};

export const OrderItemTableRowContainerSX = (id: string, lastRow = false): SxProps<Theme> => ({
	px: 0,
	pt: id === '0' ? 0 : '10px',
	pb: lastRow ? 0 : '10px',
	borderBottom: lastRow ? 'none' : '1px solid grey.50',
});
